/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

import {resolveLegacyUrl} from './legacy-route-resolver.js';
const script=document.querySelector('script[data-legacy-routes]');
// The exact known routes also have permanent Shopify redirects. This adapter
// handles query translation and dynamic legacy paths Shopify cannot wildcard.
if(script) {
  const path=location.pathname;
  if(script.dataset.notFound==='true'||/^\/search(?:\/|$)/.test(path)||path==='/blogs/nail-style-blog'||path==='/nail-style-blog'||/^\/virtual-salon\//.test(path)) {
    fetch(script.dataset.legacyRoutes).then(response=>{if(!response.ok)throw new Error();return response.json();}).then(manifest=>{
      const target=resolveLegacyUrl(location.href,manifest);
      if(!target)return;
      const destination=document.querySelector('[data-legacy-destination]');
      if(destination){destination.href=target;destination.hidden=false;}
      // Sign-out only occurs through a deliberate user navigation to its URL.
      location.replace(target);
    }).catch(()=>{/* The useful 404 recovery links remain available. */});
  }
}
